
import {Quiz} from "../../Shared/Model/QuizData";
import {ScoreData} from "../../Shared/Components/Score";
import {Diploma, Finish, Homepage, Play} from "../../Shared/Model/GameState";

export default class QuizStateFactory {

    static homepage() : Homepage {
        return {
            screen : "homepage"
        }
    }

    static play(quiz : Quiz) : Play {
        return {
            screen : "play",
            quiz : quiz,
            currentQuestion : 0
        }
    }

    static finish(title: string, text: string, score: ScoreData) : Finish {
        return {
            screen : "finish",
            score : score,
            title : title,
            text : text,
        }
    }

    static diploma(name: string, title: string, text: string, score: ScoreData) : Diploma {
        return {
            screen : "diploma",
            score : score,
            name : name,
            title : title,
            text : text,
        }
    }
}